import { ReportFormat, ReportFormats } from '../enums/report-format.type';
import { ScreeningProductType } from '../enums/screening-product-type';

/** The API says how each report is delivered (`ApplicationDto.reportFormats`); anything unknown is HTML. */
export function getReportFormat(
  application: { reportFormats?: ReportFormats } | undefined | null,
  productType: ScreeningProductType,
): ReportFormat {
  return application?.reportFormats?.[productType] ?? 'html';
}
